import { CompanyIntroductionStep } from './CompanyIntroductionStep';
import { CompanyPrioritiesStep } from './CompanyPrioritiesStep';
import { ProvideYourDataStep } from './ProvideYourDataStep';
import { ReviewSkillsStep } from './ReviewSkillsStep';
import { useCompanyOnboardingStore } from './use-company-onboarding-store';

import type { FunctionComponent } from 'react';

export const CompanySetupStep: FunctionComponent = () => {
    const companyOnboardingStep = useCompanyOnboardingStore((state) => state.companyOnboardingStep);

    switch (companyOnboardingStep) {
        case 'company-description':
            return <CompanyIntroductionStep />;
        case 'company-priorities':
            return <CompanyPrioritiesStep />;
        case 'cv-upload':
            return <ProvideYourDataStep />;
        case 'review-skills':
            return <ReviewSkillsStep />;
        default:
            return null;
    }
};
